import React from 'react';
import { useRecoilState } from 'recoil';
import { Box, Grid } from '@mui/material';
import { noteState } from 'features/optimization/state/cfdConfigAtoms';
import { CustomTextField } from 'shared/ui/CustomTextField';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface Props {
  label: string;
  labelXs?: number;
  fieldXs?: number;
}

export const CommentField: React.FC<Props> = ({
  label,
  labelXs = 5,
  fieldXs = 6,
}) => {
  const [cfdNote, setCfdNote] = useRecoilState(noteState);

  const handleCfdNoteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCfdNote(event.target.value); // Update the note state
  };

  return (
    <Box component="div" sx={{ paddingTop: 1 }}>
      <Grid container alignItems="center" spacing={0.5}>
        <Grid item xs={labelXs}>
          <CustomTypography>
            {label}
          </CustomTypography>
        </Grid>
        <Grid item xs={fieldXs}>
          <CustomTextField
            label="comment"
            variant="outlined"
            multiline
            minRows={1} // Number of displayed rows
            value={cfdNote} // Bind the value to the state
            onChange={handleCfdNoteChange} // Handle changes
          />
        </Grid>
      </Grid>
    </Box>
  );
};
